import { Component, OnInit, ViewChild } from '@angular/core';
import { Conjoint } from 'model/model.conjoint';
import { AdminService } from '../../../services/admin';
import { Popup } from 'ng2-opd-popup';
declare var moment: any;
declare var mdtoast: any;
var success_message = mdtoast("Opération effectué avec succès. En attante de validation par le Médecin", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var error_message = mdtoast('Vous n\'avez pas accès à cette donnée.', { duration: 5000, init: true, type: mdtoast.ERROR });

@Component({
  selector: 'app-statistique-global-agent-et-famille',
  templateUrl: './statistique-global-agent-et-famille.component.html',
  styleUrls: ['./statistique-global-agent-et-famille.component.scss']
})
export class StatistiqueGlobalAgentEtFamilleComponent implements OnInit {
  conjoint: Conjoint;
  mode_image: number = 2;
  pageConjoint: any;
  motCle: String = "";
  currentPage: number = 1;
  size: number = 15;
  @ViewChild('popup5') popup5: Popup;
  pages: Array<number>;
  public age: number;





  idconjoint: number;
  type: String;
  newConjoint: Conjoint;
  email: string;
  password: string;
  matricule: string;
  numeroEnfant: String;
  photoCode: any;
  midiam: any;
  photo64: any;
  code: string = "ABCDEFghojklm123456789";
  key: number = 5;
  pageConjointEnfant: any;
  agent_ministere = false;

  listeConjoint: any;
  pageParIm: Conjoint;
  conjointduconjoint: Conjoint;
  conjointduconjointSelected: Conjoint;
  showDropDownConjoint = false;
  photo_user_selected: any;
  id_agent_actuel: any;





  constructor(public adminService: AdminService) { 
    this.id_agent_actuel = this.adminService.getUserIdIscrit();
  }


  ngOnInit() {

    this.doSearch();

  }





  doSearch() {
    // this.conjointService.getListeAgent_etFamille(this.motCle, this.currentPage, this.size)
    this.adminService.getListeAgent(this.motCle, this.currentPage, this.size)

      .subscribe(data => {
        this.pageConjoint = data;
        if (data && data.length != 0 && data[0].infoEnregistrement.totalPages)
          this.pages = new Array(data[0].infoEnregistrement.totalPages);
        else this.pages = new Array(0);

        var mActu = moment();
        for (var i = 0; i < data.length; i++) {
          if (!this.pageConjoint[i].agent_date_naissance) continue;
          let naiss = this.pageConjoint[i].agent_date_naissance;
          if (naiss) {
            var mNaiss = moment(naiss);
            //Used Math.floor instead of Math.ceil
            //so 26 years and 140 days would be considered as 26, not 27.
            this.pageConjoint[i].age = mActu.diff(mNaiss, 'years');
          }
        }
        /*let naiss= this.pageConjoint.agent_date_naissance;                
        this.pages = new Array(data.totalPages);
        console.log(data);
         console.log("#################################");
        console.log(naiss);
         if(naiss){
            var timeDiff = Math.abs(Date.now() - naiss);
            //Used Math.floor instead of Math.ceil
            //so 26 years and 140 days would be considered as 26, not 27.
            this.age = Math.floor((timeDiff / (1000 * 3600 * 24))/365);
        }*/

      }, err => {
        console.log(err);
      })
  }



  chercher() {
    this.doSearch();
  }

  gotoPage(i: number) {
    if (i <= 0) return;
    if (i > this.pages.length) return;
    this.currentPage = i;
    this.doSearch();

  }


  onClicVieuAgent(id2: number) {
    //322670
    let im_chef = 2132 
    //320744
    let im_daf = 10319 
    //"203 131 007 842"
    let im_li = 12553 
    if(id2 != this.id_agent_actuel){
      error_message.show();  
    }else if(id2 == this.id_agent_actuel || this.id_agent_actuel == im_chef
      || this.id_agent_actuel == im_daf|| this.id_agent_actuel == im_li){
      this.adminService.getEnfant(id2)
      .subscribe(data => {
        this.testemodePhoto();
        this.conjoint = data;
        this.doSearchEnfant();
        this.doSearch1();
      },
        err => {
          console.log(err);
        })
    }


   

  }

  testemodePhoto(){
    this.adminService.newCribSubect.subscribe(
      data => {
          console.log("miandrty anao izay ooooo :" + data);
          this.photo_user_selected = data;
          if (this.photo_user_selected == "" || this.photo_user_selected.length==0) {
            this.mode_image = 1;
          }else{
            this.mode_image = 2;
          
           
          }
        }
      );
  }



  doSearch1() {
    this.adminService.recupererAgentConjoint(this.conjoint.id, this.conjoint.agent_type)
      .subscribe(data => {
        this.pageConjoint = data;

        this.popup5.options = {
          cancleBtnClass: "btn btn-danger",
          confirmBtnClass: "btn btn-success",
          color: "#A0DE4F",
          showButtons: true,
          animationDuration: 1.5,
          header: "Famille de l'Agent " + this.conjoint.agent_nom +" " +this.conjoint.agent_prenom,
          widthProsentage: 80,
          animation: "fadeInRight",
          cancleBtnContent: "Fermer",
          confirmBtnContent: "Retour"
        }
        this.popup5.show(this.popup5.options);
      }, err => {
        console.log(err);
      })
  }

  ferme(){
    this.popup5.hide();
  }

 


  getUrlImageFromServer(c : Conjoint){
    return this.adminService.getUrlImageFromServer(c);
  
}



modephodeAgent(c : Conjoint){
  
}

  doSearchEnfant() {
    this.adminService.getListeEnfantAgent(this.conjoint.id)
      .subscribe(data => {
        this.pageConjointEnfant = data;
        this.pages = new Array(data.totalPages);
        console.log(data);
      }, err => {
        console.log(err);
      })
  }

  


  FermerPopupetailAgent() {
    this.popup5.hide();
  }



  onClickApropos(id: number) {
    //afficher un nouveau composant
    // this.router.navigate(['apropos-agent', id]);
  }


  onClicVieuAgent2(id: number) {
    // this.router.navigate(['apropos_agent', id]);
  }











}
